import React from 'react';
import {CSSProperties} from 'react';

// import {utils} from '../utils';
import {theme} from '../constants';

type Props = {
  style?: CSSProperties;
  numberOfLines?: number;
  children: React.ReactNode;
};

const H2: React.FC<Props> = ({
  style,
  children,
  numberOfLines = 0,
}): JSX.Element => {
  return (
    <h2
      style={{
        fontSize: 28,
        lineHeight: 1.1,
        color: theme.colors.mainDark,
        textAlign: 'left',
        ...theme.fonts.Poppins_600SemiBold,
        ...(numberOfLines
          ? {
              display: '-webkit-box',
              WebkitBoxOrient: 'vertical',
              WebkitLineClamp: numberOfLines,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }
          : {}),
        ...style,
      }}
    >
      {children}
    </h2>
  );
};

export default H2;
